'use strict';

var React = require('react');
var ClassNames = require('classnames');
//components
var RadioInput = require('../Common/RadioInput.jsx');
//actions
var Action = require('../../actions/YourDetailsActions');
//constants
var Constants = require('../../constants/YourDetailsConstants');
var FormKeys = require('../../constants/ApplicationConstants').FormKeys;

var AddAdditionalInvestors = React.createClass({
    handleClick: function () {
        Action.addAddtionalInvestors();
    },
    getAddItemData: function () {
        switch (this.props.formKey) {
            case FormKeys.COMPANY_INVESTMENT:
            case FormKeys.PARTNERSHIP_INVESTMENT:
                return Constants.AddIndividualData;
            case FormKeys.JOINT_CHALLENGER:
            case FormKeys.JOINT_COMMINSURE:
            case FormKeys.JOINT_INVESTMENT:
                return Constants.AddInvestorData;
            default:
                return Constants.AddTrusteeData;
        }
    },
    render: function () {
        var addItemData = this.getAddItemData();
        return (
            <div className={ClassNames({ hidden: this.props.isHidden })}>
                <RadioInput id="add-new-item"
                            data={addItemData}
                            onChange={this.handleClick} />
            </div>
            );

    }
});

module.exports = AddAdditionalInvestors;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/YourDetails/AddAdditionalInvestors.jsx